import { cn } from '@/lib/cn';

export function SkeletonLine({ className }: { className?: string }) {
  return <div className={cn('skeleton h-3 rounded-md', className)} />;
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={cn('card card-pad space-y-3', className)}>
      <SkeletonLine className="w-1/4 h-2.5" />
      <SkeletonLine className="w-3/5 h-5" />
      <SkeletonLine className="w-2/5 h-2.5" />
    </div>
  );
}

export function SkeletonChart({ className }: { className?: string }) {
  return (
    <div className={cn('card card-pad', className)}>
      <SkeletonLine className="w-1/3 mb-2" />
      <SkeletonLine className="w-2/4 h-5 mb-4" />
      <div className="flex items-end gap-1.5 h-36">
        {[60, 80, 45, 90, 70, 55, 85, 65, 75, 50, 95, 40].map((h, i) => (
          <div
            key={i}
            className="skeleton flex-1 rounded-t-sm"
            style={{ height: `${h}%`, animationDelay: `${i * 0.06}s` }}
          />
        ))}
      </div>
    </div>
  );
}

export function SkeletonKpiRow({ className }: { className?: string }) {
  return (
    <div className={cn('grid grid-cols-3 gap-3', className)}>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}
